import types from "actions/actionTypes";

const userReducer = (
  state = {
    externalIds: []
  },
  action
) => {
  switch (action.type) {
    case types.SET_USER_ATTRIBUTES:
      return action.payload;
    case types.SET_USER_OFFICE:
      return { ...state, externalId: action.payload };
    default:
      return state;
  }
};

export default userReducer;
